import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { MobileService } from '../services/mobile.service';

/**
 * Blocks a route unless it's running inside the native mobile app shell. Used on
 * `/register` - account creation is mobile-only, not offered on the web app.
 *
 * Syncs `appPlatform` from the query param itself (mirroring
 * `AuthenticationGuard.canActivate`) rather than trusting `MobileService` to already be
 * current - this route isn't behind `AuthenticationGuard`, so nothing else guarantees the
 * native shell's `?appPlatform=` param has been read yet by the time this guard runs.
 */
@Injectable()
export class MobileOnlyGuard implements CanActivate {
  constructor(
    private router: Router,
    private mobileService: MobileService,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const appPlatform = route.queryParams['appPlatform'];
    if (appPlatform) {
      this.mobileService.setPlatformType(appPlatform);
    }

    if (this.mobileService.isMobileApp) {
      return true;
    }

    this.router.navigate(['/login']);
    return false;
  }
}
